import { useEffect, useState } from 'react';
import { api } from '../../api';
import { t } from '../../i18n';
import type { ParentMessage } from '../../types';
import { Button } from '../shared/Button';

type Props = {
  onAllSeen: () => void;
};

export function ParentMessageModal({ onAllSeen }: Props) {
  const [queue, setQueue] = useState<ParentMessage[] | null>(null);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    api.myMessages(true).then((res) => {
      setQueue(res.messages);
      if (res.messages.length === 0) onAllSeen();
    });
  }, [onAllSeen]);

  if (!queue || queue.length === 0) return null;
  const current = queue[index];
  if (!current) return null;

  const ack = async () => {
    await api.markMessageSeen(current.id);
    if (index + 1 < queue.length) {
      setIndex(index + 1);
    } else {
      onAllSeen();
    }
  };

  const isEmoji = current.message_type === 'emoji';
  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-bg p-6">
      <div className="text-center text-[12px] uppercase tracking-wide text-ink-subtle">
        {t('messages.from_parent')}
      </div>
      <div className="flex flex-1 items-center justify-center">
        {isEmoji ? (
          <div className="text-[80px] leading-none">{current.content}</div>
        ) : (
          <div className="max-w-md text-center text-[24px] font-medium leading-snug text-ink">
            {current.content}
          </div>
        )}
      </div>
      <Button onClick={ack} fullWidth>
        {t('messages.thanks')}
      </Button>
    </div>
  );
}
